import { render } from "./KnowledgeBase.vue?vue&type=template&id=6f6057e8&scoped=true"
import script from "./KnowledgeBase.vue?vue&type=script&lang=js"
export * from "./KnowledgeBase.vue?vue&type=script&lang=js"

import "./KnowledgeBase.vue?vue&type=style&index=0&id=6f6057e8&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6f6057e8"]])

export default __exports__